import React from 'react';

const ErrorMessage = ({ error }) => {
    try {
        const errorData = error;

        if (!errorData || typeof errorData !== 'object') {
            return <div>Ocorreu um erro na requisição.</div>;
        }

        if (errorData?.message) {
            return <div>{errorData.message}</div>;
        }

        let errorMessages = [];
        Object.keys(errorData).forEach(field => {
            const fieldErrors = errorData[field];
            if (Array.isArray(fieldErrors)) {
                errorMessages = errorMessages.concat(fieldErrors.filter(e => typeof e === 'string'));
            } else if (typeof fieldErrors === 'string') {
                errorMessages.push(fieldErrors);
            }
        });

        if (errorMessages.length === 0) {
            return <div>Ocorreu um erro na requisição.</div>;
        }

        return (
            <>
                {errorMessages.map((errorMessage, index) => (
                    <div key={index}>{errorMessage}</div>
                ))}
            </>
        );
    } catch {
        return <div>Ocorreu um erro na requisição.</div>;
    }
};

export default ErrorMessage;
